export function clientCarousel() {

	let carousel = $('.js-client-carousel');

	carousel.addClass('owl-carousel owl-theme');
	carousel.owlCarousel({
		dots: false,
		nav: false,
		items: 4,
		loop: true,
		autoplay: true,
		autoplayTimeout: 1250, // <-- 2x zo snel
		responsive: {
			0: {
				items: 1
			},
			600: {
				items: 2
			},
			991: {
				items: 3
			},
			1366: {
				items: 4
			}
		}
	})

	return 'clientCarousel';
}
